import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const CustomEcommerceWebsiteDevelopersInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Custom E-commerce Website Developers in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Tailored to Your Vision</Subheading>}
        heading={
          <Heading>
            Custom{" "}
            <span tw="text-primary-500">E-commerce Website Developers</span> in
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we are expert custom e-commerce website
            developers in **Dubai**, building unique, high-performing online
            stores designed to meet your specific business needs. Turn your
            vision into a reality with our bespoke solutions.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1607082349566-187342175e2f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // E-commerce storefront on tablet
          "https://images.unsplash.com/photo-1546213290-e1b492ab3eee?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile shopping app
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Online store dashboard
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Create Your Custom Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Custom Development Excellence in Dubai"
        description="We build e-commerce websites that are uniquely yours."
        cards={[
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Bespoke Solutions",
            description: "Tailored features to match your business goals.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Optimized",
            description: "Custom designs that drive conversions.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Scalable Systems",
            description: "Built to grow with your business.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Framework",
            description: "Robust security for your custom store.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Responsive Design",
            description: "Perfect on desktops, tablets, and phones.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Developers",
            description: "Dubai’s go-to for custom e-commerce.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Custom Development Process"
        description={
          <Description>
            We craft your custom e-commerce website with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Discovery: Understand your unique needs and vision.</li>
              <li>Design: Create a custom layout that reflects your brand.</li>
              <li>Development: Build tailored features and functionality.</li>
              <li>Testing: Ensure your site performs flawlessly.</li>
              <li>Launch: Deliver a bespoke store ready to succeed.</li>
              <li>Support: Provide ongoing customization and updates.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Web development process
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Team planning e-commerce strategy
          "https://images.unsplash.com/photo-1472437774355-71ab6752b434?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Dubai business district
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Custom Success in Dubai"
        description="Our custom websites have transformed businesses."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Unique Impact",
            description: "Custom store increased sales by 180%.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Tailored Growth",
            description: "Scaled a client’s site for 10x traffic.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Approval",
            description: "97% satisfaction from custom projects.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for a Custom Store?</Subheading>}
        heading="Custom E-commerce Developers in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset, the leading custom e-commerce website
            developers in Dubai. Get a one-of-a-kind online store built just for
            you—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Online payment/e-commerce success
          "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Dubai skyline with Burj Khalifa
          "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Custom website design concept
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "AffordableOnlineStoreDevelopmentInDubai.js60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
